import setDestinationQuery from './setDestinationQuery';
import getDestinationCountries from './getDestinationCountries';
import getDestinationSuggestions from './getDestinationSuggestions';

export default {
  setDestinationQuery,
  getDestinationCountries, // for pre-fetch
  getDestinationSuggestions, // crutch, for intialize form
};
